import { render, staticRenderFns } from "./smallCard.vue?vue&type=template&id=0adb2e02&scoped=true&"
import script from "./smallCard.vue?vue&type=script&lang=ts&"
export * from "./smallCard.vue?vue&type=script&lang=ts&"
import style0 from "./smallCard.vue?vue&type=style&index=0&id=0adb2e02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb2e02",
  null
  
)

export default component.exports